import { Avatar, AvatarImage, AvatarFallback } from "./ui/avatar";
import { fileUrl } from "../lib/api";

const initials = (name, email) => {
  const s = (name || email || "?").trim();
  const parts = s.split(/\s+/);
  if (parts.length >= 2 && parts[0] && parts[1]) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
};

export function UserAvatar({
  name,
  email,
  src,
  className = "h-9 w-9",
  fallbackClass = "bg-primary/10 text-primary font-mono text-xs font-bold",
  testid,
}) {
  return (
    <Avatar className={className} data-testid={testid}>
      {src && <AvatarImage src={fileUrl(src)} alt={name || email || "avatar"} />}
      <AvatarFallback className={fallbackClass}>{initials(name, email)}</AvatarFallback>
    </Avatar>
  );
}
